import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserIs } from 'tools/browser'
import { BrowserProvider, BrowserConsumer } from 'contexts/browser-context'
import RootErrorBoundary from 'atoms/RootErrorBoundary'
import DesktopFooter from 'organisms/Footer/DesktopFooter'
import MobileFooter from 'organisms/Footer/MobileFooter'
import { ConfigProvider } from 'contexts/config-context'
import { SettingsProvider } from 'contexts/settings-context'

class Footer extends Component {
  state = {
    browserIs: null,
  }

  componentDidMount () {
    const newState = {
      browserIs: browserIs(),
    }

    this.setState(newState)
    window.addEventListener('resize', () => {
      window.requestAnimationFrame(() => {
        this.setState({ browserIs: browserIs() })
      })
    })
  }

  render () {
    const { browserIs } = this.state
    const { config } = this.props

    if (browserIs === null) {
      return null
    }

    return (
      <RootErrorBoundary>
        <SettingsProvider>
          <ConfigProvider value={config}>
            <BrowserProvider value={browserIs}>
              <BrowserConsumer>
                {
                  browserIs =>
                    browserIs.greaterThan.large
                      ? <DesktopFooter />
                      : <MobileFooter />
                }
              </BrowserConsumer>
            </BrowserProvider>
          </ConfigProvider>

        </SettingsProvider>
      </RootErrorBoundary>
    )
  }
}

Footer.propTypes = {
  config: PropTypes.object.isRequired,
}

export default Footer



// WEBPACK FOOTER //
// ./src/Footer.js